<template>
    <tr :class="['clickable', { disabled: !entity.active}]" @click="toDetail(entity.id)">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
          <input type="checkbox"
                 :id="entity.id"
                 :value="entity.id"
                 @change="onChange"
                 :checked="isChecked"
                 @click.stop
          />
          <label :for="entity.id" @click.stop v-translate>Vybrat</label>
        </td>
        <td class="first_data" data-th="Název"><strong>{{ entity.name }}</strong></td>
        <td data-th="Typ balíčku">{{ entity.type }}</td>
    </tr>
</template>

<script>
	export default {
		name: "PackageRow",
		props: {
			entity: Object,
      selectedEntities: Array,
      isDeletable: Boolean,
      idSubscriber: Number,
		},
        methods: {
          onChange: function (e) {
            this.$emit('input', e)
          },
          toDetail(id){
              this.$router.push({name: 'vodPackagesDetail', params: {id: id}});
          },
        },
        computed: {
          isChecked() {
            return this.selectedEntities.indexOf(String(this.entity.id)) > -1
          },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/views/vodProviders/detail/PackagesRow.vue